/** User-facing validation for dyslexia screener document upload (US 29032). */

export const DYSLEXIA_SCREENER_DOCUMENT_UPLOAD_ERROR_TRAINING_PARTICIPANTS =
  'Training Participants document is required.';

export const DYSLEXIA_SCREENER_DOCUMENT_UPLOAD_ERROR_OTHER_TRAINING_PERMISSION =
  'Uploaded written permission for Training Source used Other is required.';

export const DYSLEXIA_SCREENER_DOCUMENT_UPLOAD_ERROR_MUST_BE_UPLOADED =
  'Document must be uploaded.';
